module.exports = __webpack_public_path__ + "static/media/v-icon-white.9f3ec9de.svg";